// @vendors
import { create } from "zustand";
import { persist } from "zustand/middleware";

// @services
import profileService from '../services/profile.service';

// @types
import { ProfessionalInfo, UserInfo } from "../types/profile.types";

interface CompanyState {
    data: ProfessionalInfo | null;
    isLoading?: boolean;
    companyLogo: string | any;
    userData: UserInfo | null;
    getProfessional: () => Promise<ProfessionalInfo>;
    getUser: () => Promise<UserInfo>;
    getLogo: (id: string) => any;
}

export const useCompanyStore = create(
    persist<CompanyState>(
        (set) => ({
            data: null,
            isLoading: false,
            companyLogo: "",
            userData: null,

            getProfessional: async () => {
                set({ isLoading: true });
                try {
                    const response = await profileService.fetchProfessionalTypeInfo();
                    set({ data: response, isLoading: false });
                    return response;
                } catch (error) {
                    set({ isLoading: false });
                    throw error;
                }
            },

            getUser: async () => {
                set({ isLoading: true });
                try {
                    const response = await profileService.fetchUserTypeInfo();
                    set({ userData: response, isLoading: false });
                    return response;
                } catch (error) {
                    set({ isLoading: false });
                    throw error;
                }
            },

            getLogo: (image: string) => set(() => ({ companyLogo: image }))
        }),
        {
            name: 'company-data',
        }
    )
)
